/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  mutation AccountTwoFactorAuthenticationCreateMutation($email: EmailAddress!, $token: String!) {
    AccountTwoFactorAuthenticationCreate(email: $email, token: $token) {
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
